import { AppconfigService } from './appconfig.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AuthguardService implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (AppconfigService.clgcode === undefined || AppconfigService.clgcode === null) {
        this.router.navigate(['/main'], { queryParams: { returnUrl: state.url }});
        return false;
    } else {
      return true;
    }
  }

}
